import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { homeUrl, states } from "../constant";
import { makeStyles } from "@mui/styles";
import { useNavigate,useLocation,createSearchParams} from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField
} from "@mui/material";
import Header from "./Header";
import "../pages/paymentPage.css";
import { Footer } from "./Footer";
import { useLayoutEffect } from "react";
import DataServices from "./DataServices";
import { useGlobalState } from "../globalStyle";


function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
};

const useStyles = makeStyles(() => ({
  input: {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  formsubtitle: {
    fontSize: "15px",
    textAlign: "center",
    color: "blue",
    fontWeight: 700,
    paddingBottom: "20px",
  },
}));

const Form = (data) => {
  const [productPrice, setProductPrice] = useState([]);
  const [productPriceHeader, setProductHeader] = useState("");
  const leadSquaredBody = useGlobalState("leadSquaredDataVal")[0];
  const productMainUrl = useGlobalState("PRODUCTMAINURL")[0];


  useEffect(() => {
    async function fetchData() {
      const productData = await DataServices.productData(productMainUrl);
      productData && productData.products.forEach((val) => {
        val.child.forEach((filter) => {
          if (filter.code === data.data.product_plan_id) {
            setProductPrice(filter)
            setProductHeader(filter.summaryHeaderText.headerText
            )
          }
        });
      });
    }

    if (productMainUrl) { fetchData(); }
  }, [data.data.product_plan_id, productMainUrl]);


  useEffect(() => {
  }, [productPrice]);


  const {
    clientCode,
    mobile,
    client_email,
    product_plan_id,
    first_name,
    address,
    city,
    state,
    pincode,
    return_url,
  } = data.data;

  const initialState = {
    clientCode: "",
    mobile: "",
    client_email: "",
    product_plan_id: "",
    gst: "",
    first_name: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    return_url: return_url,
  };

  const navigate = useNavigate();
  const classes = useStyles();
  const [width, height] = useWindowSize();
  const [loader, setLoader] = useState(false);
  const [validateData, setValidateData] = useState(false);
  const [disabledField, setDisabledField] = useState(false);
  const [isInvalidMobile, setInvalidMobile] = useState(false);
  const search = useLocation().search;
  const [apiResponse, setApiResponse] = useState([]);
  var paymentMethod = new URLSearchParams(search).get("paymentMethod");
  var formattype = new URLSearchParams(search).get("formattype");
  var planCode = new URLSearchParams(search).get("planCode");
  var productPlanId = new URLSearchParams(search).get("product_plan_id");
  const [selectedUccCode, setSelectedUccCode] = useState("");
  const [formWidth, setFormWidth] = useState('');
  const authorizereqUrl = useGlobalState("AUTHORIZEREQURL")[0];
  const verifyUrl = useGlobalState("VERIFYUSERS")[0];

  if (clientCode === "%22null%22" || clientCode === "null") {
    clientCode = mobile;
  }

  // useEffect(() => {
  //   if (!planCode) {
  //     navigate('/')
  //   }
  // }, [planCode])

  useEffect(() => {
    if (width > 1150) {
      setFormWidth('60%');
    } else {
      setFormWidth('100%')
    }
  }, [width])

  let validationSchema = Yup.object().shape({
    mobile: Yup.string()
      .required("Mobile number is required")
      .min(10, "Must be 10 characters")
      .max(10, "Invalid mobile number"),
    client_email: Yup.string()
      .required("Email is required")
      .email("Email is invalid"),
    first_name: Yup.string().required("First name is required"),
    city: Yup.string().required("City name is required"),
    address: Yup.string().required("Address is required"),
    pincode: Yup.string().required("Pin code is required"),
    state: Yup.string().required("State name is required"),
  });

  useEffect(() => {
    if (clientCode && client_email && mobile && first_name) {
      validationSchema = validationSchema.shape({
        address: Yup.string().notRequired("Address is not required"),
        mobile: Yup.string().notRequired("Mobile is not required"),
        city: Yup.string().notRequired("City name is not required"),
        state: Yup.string().notRequired("State name not is required"),
        pincode: Yup.string().notRequired("Pin code not is required"),
      });
      setDisabledField(true);
    }
  }, [clientCode, client_email, mobile]);

  if (validateData) {
    validationSchema = validationSchema.shape({
      address: Yup.string().notRequired("Address is not required"),
      city: Yup.string().notRequired("City name is not required"),
      state: Yup.string().notRequired("State name is not required"),
      pincode: Yup.string().notRequired("Pin code is not required"),
      mobile: Yup.string().notRequired("Mobile is not required"),
    });
  }

  const formik = useFormik({
    initialValues: initialState,
    validationSchema: validationSchema,
    validate: (values) => {
      const errors = {};
      if (!values.client_email) {
        errors.client_email = 'Email is required';
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.client_email)
      ) {
        errors.client_email = 'Invalid email address';
      }
      return errors;
    },
    onSubmit: async (data) => {
      try {
        data.clientCode = clientCode
          ? clientCode
          : data.clientCode
            ? data.clientCode
            : data.mobile;
        DataServices.callGTMStatus(data.client_email);
        setLoader(true);
        const del = data;

        formattype ? del.return_url = `${homeUrl}/payment/${paymentMethod}/paytm?formattype=custom` : del.return_url = `${homeUrl}/payment/${paymentMethod}/paytm`;

        del.product_plan_id = productPlanId ? productPlanId : planCode;

        delete data.acceptTerms;
        navigate({
          pathname: "/details",
          search: `?${createSearchParams({
            ...del,
            paymentMethod: paymentMethod,
            paymentGateway: "paytm",
            formattype: formattype,
            ...leadSquaredBody
          })}`,
        });
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    if (apiResponse.length > 1) {
      setSelectedUccCode(apiResponse[0].code);
    }
  }, [apiResponse]);

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  useEffect(() => {
    if (mobile && mobile.length > 9 && authorizereqUrl && verifyUrl) {
      handleMobileNumberChange({ target: { value: mobile } });
    }
  }, [mobile, disabledField,authorizereqUrl,verifyUrl]);

  const handleMobileNumberChange = async (event) => {
    const mobileNumber = event.target.value;
    if (mobileNumber.length === 10) {
      formik.setFieldValue("mobile", mobileNumber);

      const response = await DataServices.getVerifyUserData(mobileNumber,authorizereqUrl,verifyUrl);
      const data = response;

      setApiResponse(data);
      if (Array.isArray(data)) {
        const { emailId, name, code, mobilenumber } = data[0];
        formik.setFieldValue("client_email", emailId);
        formik.setFieldValue("first_name", name);
        formik.setFieldValue("clientCode", code);
        if (client_email) {
          formik.setFieldValue("client_email", client_email);
        } else {
          formik.setFieldValue("client_email", emailId);
        }

        if (first_name) {
          formik.setFieldValue("first_name", first_name);
        } else {
          formik.setFieldValue("first_name", name);
        }

        if (clientCode) {
          formik.setFieldValue("clientCode", clientCode);
        } else {
          formik.setFieldValue("clientCode", code);
        }

        if (emailId && name && code && mobilenumber) {
          setValidateData(true);
          setDisabledField(true);
        } else {
          setDisabledField(false);
          setValidateData(false);
        }
      } else {
        if (client_email) {
          formik.setFieldValue("client_email", client_email);
        }

        if (first_name) {
          formik.setFieldValue("first_name", first_name);
        }

        if (clientCode) {
          formik.setFieldValue("clientCode", clientCode);
        }
        setValidateData(false);
      }
    } else {
      setInvalidMobile(true);
    }
    if (mobileNumber.length < 10) {
      formik.setFieldValue("client_email", "");
      formik.setFieldValue("first_name", "");
      formik.setFieldValue("clientCode", "");
      setDisabledField(false);
      setValidateData(false);
    }
  };

  const handleUccCodeChange = (event) => {
    setSelectedUccCode(event.target.value);
    const selectedItem = apiResponse.find(
      (item) => item.code === event.target.value
    );
    if (selectedItem) {
      formik.setFieldValue("client_email", selectedItem.emailId);
      formik.setFieldValue("first_name", selectedItem.name);
      formik.setFieldValue("clientCode", selectedItem.code);
    }
  };

  const renderInputField = () => {
    if (apiResponse.length > 1) {
      return (
        <Grid container>
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="uccCodes"
                name="uccCodes"
                value={selectedUccCode}
                onChange={handleUccCodeChange}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  fontSize: "12px",
                }}
              >
                {apiResponse.map((item) => (
                  <FormControlLabel
                    key={item.id}
                    value={item.code}
                    control={<Radio />}
                    label={item.code}
                    componentsProps={{ typography: { variant: "body2" } }}
                    checked={selectedUccCode === item.code}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <TextField
          value={formik.values.clientCode}
          onChange={formik.handleChange}
          name="clientCode"
          disabled={disabledField}
          label="Client Code (Optional)"
          placeholder="Please enter your client code"
          fullWidth
          margin="dense"
          size="small"
          error={formik.touched.clientCode && Boolean(formik.errors.clientCode)}
          helperText={formik.touched.clientCode && formik.errors.clientCode}
        />
      );
    }
  };

  return (
    <div>
      <div
        style={{
          width: `${formattype === "custom" ? formWidth : '100%'}`,
          margin: "30px auto",
        }}
      >
        {formattype === "custom" && (
          <Header title="Get unbiased stock recommedations at Zero Brokerage to Trade Successfully" />
        )}
        <Card>
          <CardContent>
            <div className={formattype === "custom" ? "product-main-card" : ""}>
              <div className="form-title">
                <div>
                  {productPrice && (
                    <p style={{ display: formattype === "custom" ? "block" : "none" }}>
                      <b>{productPriceHeader}</b>
                    </p>

                  )}
                </div>
              </div>
              <div>
                <p className="fill-details">Fill In Your Details</p>
              </div>
              <div>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    {isInvalidMobile || !mobile ? (
                      <Grid item xs={12} sm={6}>
                        <TextField
                          value={formik.values.mobile}
                          autoFocus
                          id="mobile"
                          label="Mobile No."
                          name="mobile"
                          placeholder="Please enter mobile no."
                          fullWidth
                          className={classes.input}
                          type="number"
                          margin="dense"
                          inputProps={{
                            maxLength: 10,
                          }}
                          size="small"
                          error={
                            formik.touched.mobile &&
                            Boolean(formik.errors.mobile)
                          }
                          helperText={
                            formik.touched.mobile && formik.errors.mobile
                          }
                          onChange={(event) => {
                            const inputValue = event.target.value;

                            // Remove non-numeric characters (except digits 0-9)
                            const numericValue = inputValue.replace(
                              /[^0-9]/g,
                              ""
                            );

                            // Limit the input to 10 digits
                            const limitedValue = numericValue.slice(0, 10);

                            // Update the form field value
                            event.target.value = limitedValue;

                            if (handleMobileNumberChange) {
                              handleMobileNumberChange(event);
                            }
                            if (formik && formik.handleChange) {
                              formik.handleChange(event);
                            }
                          }}
                        />
                      </Grid>
                    ) : null}

                    {!clientCode && (
                      <Grid item xs={12} sm={6}>
                        {renderInputField()}
                      </Grid>
                    )}
                    {!first_name && (
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          id="first_name"
                          name="first_name"
                          disabled={disabledField}
                          label="Name"
                          size="small"
                          value={formik.values.first_name}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.first_name &&
                            Boolean(formik.errors.first_name)
                          }
                          helperText={
                            formik.touched.first_name &&
                            formik.errors.first_name
                          }
                        />
                      </Grid>
                    )}

                    {!client_email && (
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          id="client_email"
                          name="client_email"
                          label="Email"
                          size="small"
                          disabled={disabledField}
                          value={formik.values.client_email}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.client_email &&
                            Boolean(formik.errors.client_email)
                          }
                          helperText={
                            formik.touched.client_email &&
                            formik.errors.client_email
                          }
                        />
                      </Grid>
                    )}
                    {!address && (
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          id="address"
                          name="address"
                          label="Address"
                          disabled={disabledField}
                          size="small"
                          value={formik.values.address}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.address &&
                            Boolean(formik.errors.address)
                          }
                          helperText={
                            formik.touched.address && formik.errors.address
                          }
                        />
                      </Grid>
                    )}
                    {!city && (
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          id="city"
                          name="city"
                          label="City"
                          disabled={disabledField}
                          size="small"
                          value={formik.values.city}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.city && Boolean(formik.errors.city)
                          }
                          helperText={formik.touched.city && formik.errors.city}
                        />
                      </Grid>
                    )}
                    {!state && (
                      <Grid item xs={12} sm={6} disabled={disabledField}>
                        {!state && (
                          <FormControl fullWidth>
                            <InputLabel
                              size="small"
                              disabled={disabledField && !state}
                            >
                              State
                            </InputLabel>
                            <Select
                              value={formik.values.state}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={formik.touched.state && Boolean(formik.errors.state)}
                              label="State"
                              id="state-select"
                              name="state"
                              size="small"
                              disabled={disabledField && !state}
                            >
                              {states.map((state, i) => (
                                <MenuItem key={i} value={state} style={{ fontSize: 12 }}>
                                  {state}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText error>
                              {formik.touched.state && formik.errors.state}
                            </FormHelperText>

                          </FormControl>
                        )}
                      </Grid>
                    )}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        id="pinCode"
                        name="pincode"
                        label="Pin Code"
                        disabled={disabledField}
                        size="small"
                        inputProps={{
                          maxLength: 6,
                        }}
                        value={formik.values.pincode}
                        onChange={(e) => {
                          // Use a regular expression to allow only numbers
                          const inputValue = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          formik.handleChange(e);
                          formik.setFieldValue("pincode", inputValue);
                        }}
                        error={
                          formik.touched.pincode &&
                          Boolean(formik.errors.pincode)
                        }
                        helperText={
                          formik.touched.pincode && formik.errors.pincode
                        }
                      />
                    </Grid>
                  </Grid>
                  <div className="subscribe">
                    <Button
                      className="subscribe"
                      sx={{
                        height: "38px",
                        backgroundColor: "#563EEC",
                        fontWeight: 700,
                        fontSize: "14px",
                        marginTop: "10px",
                        textTransform: "none",
                      }}
                      color="primary"
                      variant="contained"
                      type="submit"
                    >
                      <span>Submit</span>
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </CardContent>
        </Card>
        {formattype && <Footer />}
      </div>
    </div>
  );
};

export default Form;